import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "elplus_dataTables_wrapper mb-10" }
const _hoisted_2 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_3 = { class: "table-meta-info col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_4 = {
  key: 0,
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"30\">30</option><option value=\"50\">50</option><option value=\"100\">100</option><option value=\"200\">200</option>", 5)
const _hoisted_10 = [
  _hoisted_5
]
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      style: {"width":"100%"},
      size: "small",
      "tooltip-effect": "dark",
      onSelectionChange: _ctx.handleSelectionChange
    }, {
      default: _withCtx(() => [
        (_ctx.selection)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "selection",
              width: "45"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableColumns, (col, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (col.slot)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: col.label,
                  width: col.width,
                  align: col.align,
                  "show-overflow-tooltip": col.showOverflowTooltip
                }, {
                  default: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, col.prop, {
                      row: scope.row
                    })
                  ]),
                  _: 2
                }, 1032, ["label", "width", "align", "show-overflow-tooltip"]))
              : (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  label: col.label,
                  prop: col.prop,
                  width: col.width,
                  align: col.align,
                  "show-overflow-tooltip": col.showOverflowTooltip
                }, null, 8, ["label", "prop", "width", "align", "show-overflow-tooltip"]))
          ], 64))
        }), 128))
      ]),
      _: 3
    }, 8, ["data", "onSelectionChange"]),
    (_ctx.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.enableItemsPerPageDropdown)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.rowsPerPage) = $event)),
                      name: "kt_customers_table_length",
                      class: "form-select form-select-sm form-select-solid",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                    }, _hoisted_10, 544), [
                      [_vModelSelect, _ctx.pagination.rowsPerPage]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.translate("common.records", [
              _ctx.rowsStartNumber,
              _ctx.rowsEndNumber,
              _ctx.pagination.total,
            ])), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.pagination.page,
              "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.page) = $event)),
              onCurrentChange: _ctx.currentPageChange,
              "page-size": _ctx.pagination.rowsPerPage,
              "pager-count": _ctx.isMobile ? 5 : 7,
              layout: "prev, pager, next",
              total: _ctx.pagination.total,
              "hide-on-single-page": true,
              background: ""
            }, null, 8, ["current-page", "onCurrentChange", "page-size", "pager-count", "total"])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}